<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div></div>
    <button mat-icon-button (click)="dialogRef.close()">
        <mat-icon class="mat-18">clear</mat-icon>
    </button>
</div>

<pdf-viewer
    [src]="{ url: data.url }"
    [render-text]="true"
    [original-size]="false"
    [ngStyle]="{
        height: data.height + 'px'
    }"
></pdf-viewer>
